export const URL = "";
// export const BASE_URL = "https://dreamlogodesign.net/dev/mylocalmerchantservices/public/index.php/api";
// export const SERVER_URL = "https://dreamlogodesign.net/dev/mylocalmerchantservices/public/";

export const BASE_URL = "http://159.203.97.197/mylocalmerchantservices/public/api";
export const SERVER_URL = "http://159.203.97.197/mylocalmerchantservices/public/";
export const IMAGE_BASE_URL = "http://159.203.97.197/mylocalmerchantservices/storage/app/public/";

// https://dreamlogodesign.net/dev/mylocalmerchantservices/public/index.php/api/registration